<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="glossy">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          Sepet App Otro
        </q-toolbar-title>

        <div>Quasar v{{ $q.version }}</div>
      </q-toolbar>
    </q-header>

    <q-footer>
      <q-tabs>
        <q-route-tab
          v-for="nav in navs"
          :key="nav.label"
          :to="{name: nav.name}"
          :icon="nav.icon"
          :label="nav.label" />
      </q-tabs>
    </q-footer>

    <q-drawer
      v-model="leftDrawerOpen"
      bordered
      content-class="bg-grey-2"
    >
      <q-list>
        <q-item-label header>Menu Otro Layout</q-item-label>
                  
        <q-item v-for="item in menu"
          clickable 
          tag="a" 
          exact
          :key="item.label"
          :to="{name:item.name}">

          <q-item-section avatar>
            <q-icon :name="item.icon" />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{item.label}}</q-item-label>
            <q-item-label caption></q-item-label>
          </q-item-section>
        </q-item>
        
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view/>
    </q-page-container>
  </q-layout>
</template>

<script>
import {userService} from '@/_services/user.service';
import {mapGetters} from 'vuex';

export default {
  name: 'LayoutOtro',

  components: {
    
  },

  data () {
    return {
      // leftDrawerOpen: this.$q.platform.is.desktop,
      leftDrawerOpen: false,
      menu: [
          {
            label: 'Inicio',
            icon: 'home',
            to: '/',
            name: 'home',
            caption: 'pag principal'
          },
          {
            label: 'About2',
            icon: 'view_list',
            to: 'xx',
            name: 'about2',
            caption: 'about 2'
          },
          {
            label: 'Flex',
            icon: 'view_list',
            to: 'xx',
            name: 'flexbox',
            caption: 'pruebas'
          }
        ],
      navs: [
          {
            label: 'Inicio',
            icon: 'home',
            to: '/',
            name: 'home'
          },
          {
            label: 'About2',
            icon: 'view_list',
            to: 'xx',
            name: 'about2'
          },
        ]
    }
  },

  computed: {
    ...mapGetters(['isAuthenticated', 'getToken'])
  },
  methods: {
    // pasar a actions
    logout() {
      userService.logout()
      .then( data => {
        console.log('logout menu layout: ', data);
        this.$store.commit('setUser', {token: ''})
        this.$router.push({name: 'home'});
      })
      
    }
  }
}
</script>

<style>
</style>
